/**
 * Removes the brand name specified in the environment variable `NEXT_PUBLIC_BRAND_NAME`
 * and the optional "/page" segment from the beginning of a given link.
 *
 * - If a locale (e.g., "en", "nl-be") is present at the start, it is preserved.
 * - If the brand is directly at the start (e.g., "aeromoov/page/..."), it is removed.
 *
 * @param {string} link - The URL path to clean (e.g., "/nl-be/aeromoov/page/contact").
 * @returns {string} The cleaned URL with the brand name and optional "/page" segment removed.
 *
 * @example
 * '/de/aeromoov/page/instant-travel-cot-x' => 'de/instant-travel-cot-x'
 * '/nl-be/aeromoov/blog/some-url'         => 'nl-be/blog/some-url'
 * '/aeromoov/page/some-url'               => 'some-url'
 * '/en/aeromoov/some-dir/some-url'        => 'en/some-dir/some-url'
 * '/aeromoov/some-url'                    => 'some-url'
 */
export function removeBrandAndPageFromLink(link: string): string {
  if (!link) {
    console.error('link is missing in removeBrandAndPageFromLink()');
    return link;
  }

  const brandName = process.env['NEXT_PUBLIC_BRAND_NAME'];
  if (!brandName) {
    console.error('Brand name environment variable (NEXT_PUBLIC_BRAND_NAME) is not set.');
    return link;
  }

  const pattern = new RegExp(`^(/(?:[a-z]{2}(?:-[a-z]{2})?/)?)(?:${brandName})(?:/page)?/`, 'i');

  return link.replace(pattern, '$1');
}
